import { useState, useEffect } from 'react';
import { supabase } from '../supabase';
import { useAuth } from '../contexts/AuthContext';

function Home({ setPaginaAtiva }) {
  const { usuario, podeVerAds, podeVerSocial, podeVerFinanceiro, isAdmin } = useAuth();
  const [statsAds, setStatsAds] = useState({ clientes: 0 });
  const [statsSocial, setStatsSocial] = useState({ clientes: 0, concluidos: 0, naoIniciados: 0 });
  const [statsFinanceiro, setStatsFinanceiro] = useState({ receita: 0 });
  const [statsClientes, setStatsClientes] = useState({ total: 0, ativos: 0 });

  useEffect(() => {
    if (podeVerAds) carregarStatsAds();
    if (podeVerSocial) carregarStatsSocial();
    if (podeVerFinanceiro) carregarStatsFinanceiro();
    if (isAdmin) carregarStatsClientes();
  }, [usuario]);

  const carregarStatsAds = async () => {
    const { data } = await supabase.from('clientes').select('id').eq('modulo_ads', true).eq('ativo', true);
    setStatsAds({ clientes: data?.length || 0 });
  };

  const carregarStatsSocial = async () => {
    const { data: clientes } = await supabase.from('clientes').select('id').eq('modulo_social', true).eq('ativo', true);
    const total = clientes?.length || 0;
    const mesRef = `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-01`;
    const { data: etapas } = await supabase.from('social_etapas').select('id').eq('ativo', true);
    const totalEtapas = etapas?.length || 0;
    let concluidos = 0, naoIniciados = 0;
    if (clientes?.length && totalEtapas) {
      for (const c of clientes) {
        const { data: checks } = await supabase.from('social_checklist').select('concluido').eq('cliente_id', c.id).eq('mes_ref', mesRef);
        const concluidosCliente = (checks || []).filter(ch => ch.concluido).length;
        if (concluidosCliente === totalEtapas) concluidos++;
        else if (concluidosCliente === 0) naoIniciados++;
      }
    }
    setStatsSocial({ clientes: total, concluidos, naoIniciados });
  };

  const carregarStatsFinanceiro = async () => {
    const mes = new Date().getMonth() + 1;
    const ano = new Date().getFullYear();
    const { data } = await supabase.from('pagamentos').select('valor').eq('mes', mes).eq('ano', ano).eq('pago', true);
    const receita = (data || []).reduce((acc, p) => acc + Number(p.valor), 0);
    setStatsFinanceiro({ receita });
  };

  const carregarStatsClientes = async () => {
    const { data } = await supabase.from('clientes').select('id, ativo');
    setStatsClientes({ total: data?.length || 0, ativos: data?.filter(c => c.ativo).length || 0 });
  };

  const formatarMoeda = (val) => `R$ ${(val / 1000).toFixed(1)}k`;

  const hora = new Date().getHours();
  const saudacao = hora < 12 ? 'Bom dia' : hora < 18 ? 'Boa tarde' : 'Boa noite';
  const diasSemana = ['domingo','segunda-feira','terça-feira','quarta-feira','quinta-feira','sexta-feira','sábado'];
  const meses = ['janeiro','fevereiro','março','abril','maio','junho','julho','agosto','setembro','outubro','novembro','dezembro'];
  const hoje = new Date();
  const dataFormatada = `${diasSemana[hoje.getDay()]}, ${hoje.getDate()} de ${meses[hoje.getMonth()]} de ${hoje.getFullYear()}`;

  const modulos = [
    {
      id: 'ads',
      nome: 'Ads',
      desc: 'Performance de campanhas, lançamento de métricas e IA de briefing',
      icon: '◈',
      acesso: podeVerAds,
      stats: [
        { val: statsAds.clientes, label: 'clientes ativos' },
      ]
    },
    {
      id: 'social',
      nome: 'Social Media',
      desc: 'Checklist mensal, calendário de conteúdo e acompanhamento de posts',
      icon: '◎',
      acesso: podeVerSocial,
      stats: [
        { val: statsSocial.clientes, label: 'clientes ativos' },
        { val: statsSocial.concluidos, label: 'concluídos', cor: '#22c55e' },
        { val: statsSocial.naoIniciados, label: 'não iniciados', cor: statsSocial.naoIniciados > 0 ? '#ef4444' : '#fff' },
      ]
    },
    {
      id: 'financeiro',
      nome: 'Financeiro',
      desc: 'Fluxo de caixa, despesas fixas e receitas da agência',
      icon: '↑',
      acesso: podeVerFinanceiro,
      stats: [
        { val: formatarMoeda(statsFinanceiro.receita), label: 'recebido este mês', cor: '#22c55e' },
      ]
    },
    {
      id: 'clientes',
      nome: 'Clientes',
      desc: 'Cadastro central, módulos ativos e integrações por cliente',
      icon: '✦',
      acesso: isAdmin,
      stats: [
        { val: statsClientes.total, label: 'clientes total' },
        { val: statsClientes.ativos, label: 'ativos', cor: '#22c55e' },
      ]
    },
  ];

  const modulosVisiveis = modulos.filter(m => m.acesso);

  return (
    <div>
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-white">{saudacao}, {usuario?.nome}</h1>
        <p className="text-sm mt-1" style={{ color: '#555' }}>{dataFormatada}</p>
      </div>

      <div className={`grid gap-4 ${modulosVisiveis.length === 1 ? 'grid-cols-1 max-w-md' : 'grid-cols-2'}`}>
        {modulosVisiveis.map((modulo) => (
          <div key={modulo.id} onClick={() => setPaginaAtiva(modulo.id)}
            className="rounded-xl p-6 cursor-pointer transition-all"
            style={{ backgroundColor: '#111', border: '1px solid #1a1a1a' }}
            onMouseEnter={(e) => e.currentTarget.style.border = '1px solid #333'}
            onMouseLeave={(e) => e.currentTarget.style.border = '1px solid #1a1a1a'}>
            <div className="flex items-start justify-between mb-4">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center text-lg"
                style={{ backgroundColor: '#1a1a1a', color: '#DCF127' }}>
                {modulo.icon}
              </div>
              <span style={{ color: '#333', fontSize: '18px' }}>→</span>
            </div>
            <h2 className="text-white font-semibold text-base mb-1">{modulo.nome}</h2>
            <p className="text-xs mb-5" style={{ color: '#555', lineHeight: '1.5' }}>{modulo.desc}</p>
            <div className="flex gap-5 pt-4" style={{ borderTop: '1px solid #1a1a1a' }}>
              {modulo.stats.map((stat, i) => (
                <div key={i}>
                  <p className="text-lg font-bold" style={{ color: stat.cor || '#fff' }}>{stat.val}</p>
                  <p className="text-xs" style={{ color: '#555' }}>{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Home;